import React, { useEffect, useState } from "react";
import "./Dashboard.css";
import Search from "./Search";
import useAuth from "../../../hooks/useAuth";
import Filter from "../../../components/introSection/Filter";
import ArtistCard from "../../../components/cards/artistCard";
import { useDispatch, useSelector } from "react-redux";
import BookingCard from "../ArtistProfile/BookingSection/BookingCard";
import BookingComponent from "./BookingSection";
import CancelIcon from "@mui/icons-material/Cancel";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import HomeSection from "./HomeSection";
import { useNavigate } from "react-router-dom";
import Transactions from "./TransactionSection/index";
import EditIcon from "@mui/icons-material/Edit";
import {
  getProfile,
  upsertProfile,
} from "../../../redux/slices/artistProfileSlice";
import { notifyError } from "../../../utils";
import { ToastContainer } from "react-toastify";

const Dashboard = () => {
  // State to track active sidebar item
  const [activeMenu, setActiveMenu] = useState("home");
  const navigate = useNavigate();
  const { user } = useAuth();
  const dispatch = useDispatch();

  const [formData, setFormData] = useState({});

  useEffect(() => {
    if (user?.type === "artist") {
      navigate("/dashboard/artist");
    }
    setFormData({
      email: user?.email,
      username: user?.username,
    });
  }, [user]);

  // State to track if mobile menu is open
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  // State for profile editing
  const [isEditingProfile, setIsEditingProfile] = useState(false);
  // State for user profile data

  // State for form input during editing

  // Sample data for upcoming bookings

  // Sample data for trending artists
  const { artists, loading, error } = useSelector((state) => state.artists);
  // Toggle mobile menu
  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  // Handle menu item click
  const handleMenuClick = (menu) => {
    setActiveMenu(menu);
    setMobileMenuOpen(false); // Close mobile menu after selection
  };

  // Handle edit profile button click
  function isValidEmail(email) {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  }
  const handleEditProfile = () => {
    if (formData?.username?.length < 3) {
      notifyError("Username must be of atlease 3 length");
      return;
    }
    if (!isValidEmail(formData?.email)) {
      notifyError("Email is not valid");
      return;
    }
    if (isEditingProfile) {
      // Save the changes

      setIsEditingProfile(false);
      dispatch(upsertProfile(formData))
        .then(() => {})
        .catch((e) => {
          notifyError("Something wend wrong!");
        });
    } else {
      // Enter edit mode

      setIsEditingProfile(true);
    }
  };

  // Handle input change in edit mode
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  // Handle cancel edit
  const handleCancelEdit = () => {
    setIsEditingProfile(false);
  };

  // Content components for different menu items
  const renderContent = () => {
    switch (activeMenu) {
      case "home":
        return (
          <>
            <HomeSection
              username={user?.username}
              setActiveMenu={setActiveMenu}
            />
          </>
        );
      case "bookings":
        return (
          <section className="bookings-section">
            <BookingComponent />
          </section>
        );
      case "transactions":
        return (
          <section className="bookings-section">
            <Transactions />
          </section>
        );
      case "findArtists":
        return (
          <section className="find-artists-section">
            <div className="find-artist-flex">{/* <Search /> */}</div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexDirection: "column",
              }}
            >
              <h2>Find Artists</h2>
              <div style={{ width: "80%" }}>
                <Filter
                  dimensions={[
                    {
                      key: "category",
                      label: "Artist Type",
                      options: [
                        { value: "musician", label: "Musician" },
                        { value: "dancer", label: "Dancer" },
                        { value: "magician", label: "Magician" },
                        { value: "painter", label: "Painter" },
                      ],
                    },
                  ]}
                />
              </div>
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                marginTop: "2rem",
                gap: "2rem",
                flexWrap: "wrap",
              }}
            >
              {artists?.length > 0 ? (
                artists.map((artist) => <ArtistCard artist={artist} />)
              ) : !loading && artists?.length === 0 ? (
                <div>No results found</div>
              ) : null}
            </div>
          </section>
        );
      case "profile":
        return (
          <section className="profile-section">
            <h2 style={{ textAlign: "center" }}> Your Profile Details</h2>
            <div className="center">
              <div className="profile-container">
                <div className="profile-header">
                  {!isEditingProfile && (
                    <div className="profile-details">
                      <p>Username: {formData?.username}</p>
                      <p>Email: {formData?.email}</p>
                    </div>
                  )}
                </div>
                <div className="profile-body">
                  {isEditingProfile ? (
                    // Edit Form
                    <>
                      <div className="cancel">
                        <CancelIcon
                          onClick={handleCancelEdit}
                          style={{ height: "20px", width: "20px" }}
                        />
                      </div>
                      <div className="info-group">
                        <label style={{ minWidth: "80px" }}>Email </label>
                        <input
                          type="text"
                          name="email"
                          value={formData?.email}
                          onChange={handleInputChange}
                          style={{
                            padding: "5px",
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                            width: "100%",

                            color: "#fff",

                            marginLeft: "8px",
                          }}
                        />
                      </div>
                      <div className="info-group">
                        <label style={{ minWidth: "80px" }}>Username </label>
                        <input
                          type="text"
                          name="username"
                          value={formData?.username}
                          onChange={handleInputChange}
                          style={{
                            padding: "5px",
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                            width: "100%",
                            maxWidth: "300px",
                            color: "#fff",
                            marginLeft: "8px",
                          }}
                        />
                      </div>

                      <div
                        style={{
                          display: "flex",
                          gap: "10px",
                          width: "100%",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <button
                          className="edit-profile"
                          onClick={handleEditProfile}
                          style={{
                            backgroundColor: "#5cb85c",
                            color: "white",
                            border: "none",
                            padding: "10px 20px",
                            borderRadius: "5px",
                            cursor: "pointer",
                            marginTop: "15px",
                          }}
                        >
                          Save Changes
                        </button>
                        {/* <button
                          onClick={handleCancelEdit}
                          style={{
                            backgroundColor: "black",
                            color: "white",
                            border: "none",
                            padding: "10px 20px",
                            borderRadius: "5px",
                            cursor: "pointer",
                            marginTop: "15px",
                          }}
                        >
                          Cancel
                        </button> */}
                      </div>
                    </>
                  ) : (
                    // Display View
                    <>
                      <EditIcon
                        style={{
                          position: "absolute",
                          right: "12px",
                          top: "12px",
                        }}
                        onClick={handleEditProfile}
                      />
                    </>
                  )}
                </div>
              </div>
            </div>
          </section>
        );
      default:
        return <div>Content not found</div>;
    }
  };

  return (
    <div className="dashboard-container">
      <ToastContainer />
      {/* Mobile Menu Button */}
      <div className="mobile-menu-button" onClick={toggleMobileMenu}>
        <span className="mobile-menu-icon">☰</span>
      </div>

      {/* Sidebar - with mobile responsive classes */}
      <div className={`sidebar ${mobileMenuOpen ? "mobile-open" : ""}`}>
        <div className="sidebar-close-btn" onClick={toggleMobileMenu}>
          <span>×</span>
        </div>
        <div
          className={`sidebar-item ${activeMenu === "home" ? "active" : ""}`}
          onClick={() => handleMenuClick("home")}
        >
          <i className="icon-home"></i>
          <span> Dashboard</span>
        </div>
        <div
          className={`sidebar-item ${
            activeMenu === "bookings" ? "active" : ""
          }`}
          onClick={() => handleMenuClick("bookings")}
        >
          <i className="icon-calendar"></i>
          <span>Bookings</span>
        </div>
        <div
          className={`sidebar-item ${
            activeMenu === "findArtists" ? "active" : ""
          }`}
          onClick={() => handleMenuClick("findArtists")}
        >
          <i className="icon-search"></i>
          <span>Find Artists</span>
        </div>
        <div
          className={`sidebar-item ${
            activeMenu === "transactions" ? "active" : ""
          }`}
          onClick={() => handleMenuClick("transactions")}
        >
          <i className="icon-search"></i>
          <span>Transactions</span>
        </div>
        <div
          className={`sidebar-item ${activeMenu === "profile" ? "active" : ""}`}
          onClick={() => handleMenuClick("profile")}
        >
          <i className="icon-user"></i>
          <span>Profile</span>
        </div>
      </div>

      {/* Main Content */}
      <div className="main-content">
        {/* Header */}

        {/* Dynamic Content based on activeMenu state */}
        {renderContent()}
      </div>
    </div>
  );
};

export default Dashboard;
